<p>{{ workPhone | phoneNumber : 'US' }}</p>
